// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2YLTi","clinicsSelect":"TableHeading_clinicsSelect__2DJyQ"};